import { useMemo } from "react";
import { PORT_VIEW } from "./portDetailsHook";

type pointerType = "bandwidth" | "cross-connect" | "none";
export interface leftRightContextType {
  leftPointer: number | undefined;
  leftType: pointerType;
  rightType: pointerType;
  rightPointer: number | undefined;
  type: pointerType;
}
function useLeftRightContext(leftDetails: PORT_VIEW | null, rightDetails: PORT_VIEW | null) {
  const leftRightContext = useMemo(() => {
    if (!leftDetails || !rightDetails) {
      let details;
      if (!leftDetails) details = rightDetails;
      if (!rightDetails) details = leftDetails;
      return {
        type: "none",
        leftPointer: details?.bandwidth_port_id,
        leftType: details?.bandwidth_port_id ? "bandwidth" : "none",
        rightPointer: details?.cross_connect_port_id,
        rightType: details?.cross_connect_port_id ? "cross-connect" : "none",
      };
    }
    if (leftDetails.bandwidth_port_id === rightDetails.nr_id && rightDetails.bandwidth_port_id === leftDetails.nr_id) {
      return {
        leftPointer: leftDetails?.cross_connect_port_id,
        leftType: leftDetails?.cross_connect_port_id ? "cross-connect" : "none",
        rightPointer: rightDetails?.cross_connect_port_id,
        rightType: rightDetails?.cross_connect_port_id ? "cross-connect" : "none",
        type: "bandwidth",
      };
    }
    if (leftDetails.cross_connect_port_id === rightDetails.nr_id && rightDetails.cross_connect_port_id === leftDetails.nr_id) {
      return {
        leftPointer: leftDetails?.bandwidth_port_id,
        leftType: leftDetails?.bandwidth_port_id ? "bandwidth" : "none",
        rightPointer: rightDetails?.bandwidth_port_id,
        rightType: rightDetails?.bandwidth_port_id ? "bandwidth" : "none",
        type: "cross-connect",
      };
    }
    return {
      type: "none",
      leftPointer: null,
      rightPointer: null,
      leftType: "none",
      rightType: "none",
    };
  }, [leftDetails, rightDetails]) as leftRightContextType;
  return leftRightContext;
}

export default useLeftRightContext;
